export const ProductDetailsRoute = "/products/details/";
export const OrderReviewRoute = "/cart";
export const CategoriesRoute = "/products/";
export const CustomHompepageRoute = "/home";
